var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgReload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M782.856,217.17a0.08,0.08,0,0,1-.013-0.013,400,400,0,0,0-565.686,0c-156.21,156.21-156.21,409.476,0,565.686a400,400,0,0,0,565.686,0L676.777,676.777a250,250,0,1,1,0-353.554l0.028,0.027L575.083,425H825a50,50,0,0,0,50-50h0V125Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Reload.4ec28743.svg";
export { ForwardRef as ReactComponent };